import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// We deliberately do NOT persist the JWT to localStorage anymore.
// Auth is held in an httpOnly cookie set by the backend; the store only
// caches the current user profile so the UI can render synchronously.
// `hydrated` flips true once /auth/me has settled (either with a user or with a 401).
export const useAuthStore = create(
  persist(
    (set) => ({
      user: null,
      hydrated: false,
      lastActivityAt: Date.now(),
      setUser: (user) => set({ user, hydrated: true, lastActivityAt: Date.now() }),
      updateUser: (patch) => set((s) => ({ user: { ...(s.user || {}), ...patch } })),
      touch: () => set({ lastActivityAt: Date.now() }),
      clear: () => set({ user: null, hydrated: true }),
    }),
    {
      name: 'payroll-auth',
      partialize: (s) => ({ user: s.user }),
    }
  )
);
